module.exports = __webpack_public_path__ + "img/00035.46179558.webp";